module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "calibre_toc_4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ebook_split_006#_idTextAnchor000"
    }
  }, [_vm._v("Foreword"), _c('span', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("When the idea of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Postcards to the Universe ")]), _vm._v("was born, I knew it was going to turn into a global movement. Melisa has discovered a new twist to manifesting: to be the creator of your reality and to direct your destiny, your vision and intention must seamlessly come"), _c('span'), _vm._v("together.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Very early on in this project, I would ask Melisa to come to my live classes and share her postcards with my students. I was teaching them how to use the zero-point field (the energy that surrounds us), by setting clear intentions, raising their emotional frequency, and running a movie of it all in their"), _c('span'), _vm._v("minds.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Adding in the postcard component was a way for them to enhance their creative visualization with her beautiful photography and send their cards out as an action for the intention to"), _c('span'), _vm._v("manifest.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("Melisa has done an extraordinary job of combining art and manifestation, making it tangible and fun for us all to live our")]), _c('span', [_c('span', {
    staticClass: "dropcaps"
  })]), _c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("dreams.")])]), _vm._v(" "), _c('p', {
    staticClass: "postcard_author",
    attrs: {
      "id": "calibre_pb_15"
    }
  }, [_vm._v("Jennifer Grace"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Hay House Author.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65987ac8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ebook_split_008.vue
// module id = 78
// module chunks = 0